import "./Residential.module.css";
import Header from "@/reusable_sections/Header";
import ResidentialHero from "./sections/ResidentialHero";
import Services from "./sections/Services";
import ServiceAddons from "./sections/ServiceAddons";
import ProminentGetQuoteCTA from "./sections/ProminentGetQuoteCTA";
import Footer from "@/reusable_sections/Footer";
export default function ResidentialPage() {
  return <div>
      <Header />
      <ResidentialHero />
      <Services />
      <ServiceAddons />
      <ProminentGetQuoteCTA />
      <Footer />
    </div>;
}